import { render, staticRenderFns } from "./TTCCategoryField.vue?vue&type=template&id=3fd65224&"
import script from "./TTCCategoryField.vue?vue&type=script&lang=js&"
export * from "./TTCCategoryField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports